import React, { useState, useEffect, useRef } from "react";
import styles from './user.module.css';
import eye from '../../images/eye.svg';
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, Link, useLocation } from "react-router-dom";
import {
  EDIT_FIRST_NAME_REGISTER, EDIT_LAST_NAME_REGISTER, EDIT_SURNAME_REGISTER,
  EDIT_EMAIL_REGISTER, EDIT_FIRST_PASSWORD, EDIT_SECOND_PASSWORD, SWITCH_CHECKBOX_PERMISSION,
  postRegisterThunk, EDIT_PHONE_REGISTER
} from "../../services/actions/register_form_actions";
import { checkInput } from "../../utils/util_functions";
import Captcha from "../../components/captcha/captcha";
import { NOT_EQUAL_PASSWORDS } from "../../utils/constants";
import { getDataFromRoutes, setMetaTags, generateCode } from "../../utils/util_functions";
import { getRegisterForm, getLoading } from "../../services/selectors";
import Loader from "../../components/loader/loader";
import { CLEAR_PATH_PARAMS } from "../../services/actions/path_params_actions";
import { ROUTES_CONST } from "../../utils/constants";


const Register = () => {

  const [statusFirstName, setStatusFirstName] = useState({});
  const [statusLastName, setStatusLastName] = useState({});
  const [statusSurname, setStatusSurname] = useState({});
  const [statusPhone, setStatusPhone] = useState({});
  const [statusEmail, setStatusEmail] = useState({});
  const [statusFirstPassword, setStatusFirstPassword] = useState({});
  const [statusSecondPassword, setStatusSecondPassword] = useState({});
  const [equalPasswords, setEqualPasswords] = useState(true);
  const [code, setCode] = useState();
  const [validCaptcha, setValidCaptcha] = useState(true);

  const [formValid, setFormValid] = useState(false);

  const refToFPInput = useRef(null);
  const refToSPInput = useRef(null);
  const captchaRef = useRef(null);



  const {
    first_name, last_name, surname, phone, email,
    first_password, second_password, checkbox_permission
  } = useSelector(getRegisterForm);
  const isLoading = useSelector(getLoading);

  const location = useLocation();
  const {
    title, metaTitle, metaDescription, metaKeywords, metaRobots
  } = getDataFromRoutes(location.pathname, ROUTES_CONST);
  useEffect(() => {
    setMetaTags(metaTitle, metaDescription, metaKeywords, metaRobots);
    // eslint-disable-next-line
  }, []);



  useEffect(() => {
    setEqualPasswords(first_password === second_password);
    setFormValid(
      statusFirstName?.valid && statusLastName?.valid && statusSurname?.valid &&
      statusEmail?.valid && statusPhone?.valid && statusFirstPassword?.valid &&
      statusSecondPassword?.valid && equalPasswords && checkbox_permission && validCaptcha
    );
    // eslint-disable-next-line
  }, [
    first_password, second_password, first_name, last_name, surname,
    phone, email, checkbox_permission, equalPasswords, validCaptcha
  ]);


  const dispatch = useDispatch();

  const navigate = useNavigate();

  useEffect(() => {
    dispatch({ type: CLEAR_PATH_PARAMS });
    // eslint-disable-next-line
  }, [location]);


  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(
      postRegisterThunk(
        first_name, last_name, surname, phone, email.toLowerCase(), first_password, navigate
      )
    );
  }

  const changeFirstName = (e) => {
    if (e.target.value.length > 34) {
      e.target.value = e.target.value.slice(0, 34);
    }
    const currStatus = checkInput(e.target.value, 2, 34, 'string');
    setStatusFirstName({ ...statusFirstName, valid: currStatus.valid, text: currStatus.text });
    dispatch({ type: EDIT_FIRST_NAME_REGISTER, first_name: e.target.value });
  }
  const changeLastName = (e) => {
    if (e.target.value.length > 34) {
      e.target.value = e.target.value.slice(0, 34);
    }
    const currStatus = checkInput(e.target.value, 2, 34, 'string');
    setStatusLastName({ ...statusLastName, valid: currStatus.valid, text: currStatus.text });
    dispatch({ type: EDIT_LAST_NAME_REGISTER, last_name: e.target.value });
  }
  const changeSurname = (e) => {
    if (e.target.value.length > 34) {
      e.target.value = e.target.value.slice(0, 34);
    }
    const currStatus = checkInput(e.target.value, 2, 34, 'string');
    setStatusSurname({ ...statusSurname, valid: currStatus.valid, text: currStatus.text });
    dispatch({ type: EDIT_SURNAME_REGISTER, surname: e.target.value });
  }
  const changePhone = (e) => {
    if (e.target.value.length > 12) {
      e.target.value = e.target.value.slice(0, 12);
    }
    const currStatus = checkInput(e.target.value, 11, 12, 'tel');
    setStatusPhone({ ...statusPhone, valid: currStatus.valid, text: currStatus.text });
    dispatch({ type: EDIT_PHONE_REGISTER, phone: e.target.value });
  }
  const changeEmail = (e) => {
    if (e.target.value.length > 64) {
      e.target.value = e.target.value.slice(0, 64);
    }
    const currStatus = checkInput(e.target.value, 8, 64, 'email');
    setStatusEmail({ ...statusEmail, valid: currStatus.valid, text: currStatus.text });
    dispatch({ type: EDIT_EMAIL_REGISTER, email: e.target.value });
  }
  const changeFirstPassword = (e) => {
    if (e.target.value.length > 64) {
      e.target.value = e.target.value.slice(0, 64);
    }
    const currStatus = checkInput(e.target.value, 8, 64, 'password');
    setStatusFirstPassword({ ...statusFirstPassword, valid: currStatus.valid, text: currStatus.text });
    dispatch({ type: EDIT_FIRST_PASSWORD, first_password: e.target.value });
  }
  const changeSecondPassword = (e) => {
    if (e.target.value.length > 64) {
      e.target.value = e.target.value.slice(0, 64);
    }
    const currStatus = checkInput(e.target.value, 8, 64, 'password');
    setStatusSecondPassword({ ...statusSecondPassword, valid: currStatus.valid, text: currStatus.text });
    dispatch({ type: EDIT_SECOND_PASSWORD, second_password: e.target.value });
  }
  const changeVisibilityFP = () => {
    refToFPInput.current.type === 'password' ?
      refToFPInput.current.type = 'string' :
      refToFPInput.current.type = 'password';
  }
  const changeVisibilitySP = () => {
    refToSPInput.current.type === 'password' ?
      refToSPInput.current.type = 'string' :
      refToSPInput.current.type = 'password';
  }
  const changeCheckPermission = (e) => {
    dispatch({
      type: SWITCH_CHECKBOX_PERMISSION,
      checkbox_permission: e.target.checked
    });
  }


  return (
    <main className='main'>
      {isLoading ? <Loader /> : null}
      <h1 className="title title__left">{title}</h1>
      <div className={styles.box}>
        <form onSubmit={handleSubmit} className="form" noValidate>
          <label htmlFor="last_name" className="label_text">
            Фамилия <span style={{ color: 'red' }}>*</span>
            <input
              type="text"
              id="last_name" name="last_name"
              required={true}
              value={last_name}
              onChange={changeLastName}
              className="input"
              autoComplete="off"
            />
            <p className="error">{statusLastName?.text}</p>
          </label>
          <label htmlFor="first_name" className="label_text">
            Имя <span style={{ color: 'red' }}>*</span>
            <input
              type="text"
              id="first_name" name="first_name"
              required={true}
              value={first_name}
              onChange={changeFirstName}
              className="input"
              autoComplete="off"
            />
            <p className="error">{statusFirstName?.text}</p>
          </label>
          <label htmlFor="surname" className="label_text">
            Отчество <span style={{ color: 'red' }}>*</span>
            <input
              type="text"
              id="surname" name="surname"
              required={true}
              value={surname}
              onChange={changeSurname}
              className="input"
              autoComplete="off"
            />
            <p className="error">{statusSurname?.text}</p>
          </label>
          <label htmlFor="phone_profile" className="label_text">
            Телефон <span style={{ color: 'red' }}>*</span>
            <input
              type="tel"
              id="phone_profile" name="phone_profile"
              value={phone}
              onChange={changePhone}
              className="input"
            />
            <p className="error">{statusPhone?.text}</p>
          </label>
          <label htmlFor="email" className="label_text">
            Email <span style={{ color: 'red' }}>*</span>
            <input
              type="email"
              id="email" name="email"
              required={true}
              value={email}
              onChange={changeEmail}
              className="input"
              autoComplete="off"
            />
            <p className="error">{statusEmail?.text}</p>
          </label>
          <label htmlFor="first_password" className="label_text">
            Пароль <span style={{ color: 'red' }}>*</span>
            <input
              type="password"
              id="first_password" name="first_password"
              required={true}
              value={first_password}
              onChange={changeFirstPassword}
              className="input input__password"
              ref={refToFPInput}
              autoComplete="off"
            />
            <img src={eye} className="eye"
              alt='visibility first password' onClick={changeVisibilityFP}
            />
            <p className="error">{statusFirstPassword?.text}</p>
          </label>
          <label htmlFor="second_password" className="label_text">
            Пароль (ещё раз) <span style={{ color: 'red' }}>*</span>
            <input
              type="password"
              id="second_password" name="second_password"
              required={true}
              value={second_password}
              onChange={changeSecondPassword}
              className="input input__password"
              ref={refToSPInput}
              autoComplete="off"
            />
            <img src={eye} className="eye"
              alt='visibility second password' onClick={changeVisibilitySP}
            />
            <p className="error">
              {statusSecondPassword?.text}
              {!equalPasswords && NOT_EQUAL_PASSWORDS}
            </p>
          </label>
          <label htmlFor="check_permission" className="label_text">
            <input
              type="checkbox"
              id="check_permission" name="check_permission"
              className="checkbox"
              onChange={changeCheckPermission}
            />
            &emsp; Я даю согласие на хранение и обработку предоставленных
            персональных данных в соответствии с
            <Link to='/agreement' style={{ color: 'inherit' }}> Условиями</Link>
            &ensp;<span style={{ color: 'red' }}>*</span>
          </label>
          <label htmlFor="captcha" className="label_text">
            Защита от ботов <span style={{ color: 'red' }}>*</span>
            <Captcha
              generateCode={() => generateCode(setCode)}
              setValidCaptcha={setValidCaptcha}
              code={code}
              ref={captchaRef}
            />
            {!validCaptcha && <p className="error error_captcha">Неправильный код.</p>}
          </label>
          <button type="submit"
            className={`button ${!formValid ? 'button_disabled' : ''}`}
            disabled={!formValid}
          >
            Зарегистрироваться
          </button>
        </form>
        <div className={styles.aside_block}>
          <h2 className="subtitle subtitle__left">
            Зачем нужна регистрация?
          </h2>
          <p className="text__gray">
            Зарегистрировавшись на сайте Вы сможете получить личный кабинет,
            что позволит Вам отслеживать историю заказов, быстрее оформлять
            заказы в нашем Интернет магазине, так как вся информация о Вас
            будет доступна в нашем магазине и ее не нужно будет повторно вносить
          </p>
        </div>
      </div>
    </main>
  );
}

export default Register;
